export default __webpack_public_path__ + "static/media/Popović.af625d42.png";